import { render, staticRenderFns } from "./time-progress-item.vue?vue&type=template&id=5bb8c626&scoped=true"
import script from "./time-progress-item.vue?vue&type=script&lang=js"
export * from "./time-progress-item.vue?vue&type=script&lang=js"
import style0 from "./time-progress-item.vue?vue&type=style&index=0&id=5bb8c626&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb8c626",
  null
  
)

export default component.exports